class SyStickyCartCheckout extends HTMLElement {
  #intersectionObserver;
  #mutationObserver;
  #summary;

  connectedCallback() {
    this.hidden = false;
    this.#setVisible(false);
    this.#observeSummary();

    const cartItems = this.closest('cart-items-component');
    if (!cartItems) return;

    this.#mutationObserver = new MutationObserver(() => {
      this.#observeSummary();
    });
    this.#mutationObserver.observe(cartItems, { childList: true, subtree: true });
  }

  disconnectedCallback() {
    this.#intersectionObserver?.disconnect();
    this.#mutationObserver?.disconnect();
  }

  #observeSummary() {
    const section = this.closest('.shopify-section');
    const summary = section?.querySelector('.cart-page__summary');

    if (summary === this.#summary) return;

    this.#intersectionObserver?.disconnect();
    this.#summary = summary;
    this.#setVisible(false);

    if (!summary || !('IntersectionObserver' in window)) return;

    this.#intersectionObserver = new IntersectionObserver((entries) => {
      const entry = entries[0];
      if (!entry) return;

      this.#setVisible(!entry.isIntersecting);
    });
    this.#intersectionObserver.observe(summary);
  }

  #setVisible(visible) {
    this.toggleAttribute('data-visible', visible);
    this.toggleAttribute('inert', !visible);
    this.setAttribute('aria-hidden', String(!visible));
  }
}

if (!customElements.get('sy-sticky-cart-checkout')) {
  customElements.define('sy-sticky-cart-checkout', SyStickyCartCheckout);
}
